"use client";
import { Button } from "cy-fe";
import { signIn } from "next-auth/react";
import { BodyContainer } from "cy-remittance/components/layouts";
import * as StepWizard from "cy-ui/components/StepWizard";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { LoginRequest } from "cy-remittance/SignIn";
import { HeaderText } from "cy-remittance/components/HeaderText";
import { ErrorBanner } from "cy-remittance/components/ErrorBanner";

export interface DonePageProps {
  loginRequest: LoginRequest;
  homeUrl: string;
}
export function DonePage({ loginRequest, homeUrl }: DonePageProps) {
  const router = useRouter();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);

  async function loginHandler() {
    setError("");
    setLoading(true);

    const res = await signIn("credentials", {
      redirect: false,
      ...loginRequest,
      callbackUrl: homeUrl,
    });

    if (!res?.ok) {
      setError("Your login credentials were invalid");
      setLoading(false);
    } else {
      if (res.url == null) {
        throw new Error("res.url is null");
      }
      router.push(res.url);
    }
  }

  return (
    <StepWizard.StepPageLayout
      headerRender={() => <HeaderText>Account created</HeaderText>}
      subHeaderRender={() => <>Your account has been created successfully.</>}
    >
      <BodyContainer>
        {error ? <ErrorBanner error={error} /> : null}
        <Button
          onClick={loginHandler}
          loading={loading}
          vSize="lg"
          className="w-full"
        >
          Click here to login
        </Button>
      </BodyContainer>
    </StepWizard.StepPageLayout>
  );
}
